import { Globe, ShieldAlert, BadgeCheck, Server } from "lucide-react";

const summary = [
  {
    label: "Websites",
    value: 5,
    icon: Globe,
    color: "bg-chart-2"
  },
  {
    label: "Scans",
    value: 13,
    icon: Server,
    color: "bg-chart-1"
  },
  {
    label: "Vulnerabilities",
    value: 32,
    icon: ShieldAlert,
    color: "bg-destructive"
  },
  {
    label: "Safe",
    value: 41,
    icon: BadgeCheck,
    color: "bg-chart-4"
  }
];

export default function SummaryCards() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full mt-4">
      {summary.map(({ label, value, icon: Icon, color }) => (
        <div
          key={label}
          className="flex items-center gap-4 rounded-xl bg-card shadow p-5 border border-border min-w-[160px] animate-fade-in"
        >
          <div className={`rounded-full ${color} p-3 text-white shadow-md`}>
            <Icon size={22} />
          </div>
          <div>
            <div className="text-lg font-bold">{value}</div>
            <div className="text-xs text-muted-foreground mt-1 uppercase tracking-wider">{label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
